module.exports = __webpack_public_path__ + "assets/avatar_upload_placeholder.png";


//////////////////
// WEBPACK FOOTER
// ./assets/avatar_upload_placeholder.png
// module id = 225
// module chunks = 0